/* Quick Add (size picker) for product cards — Olive & Rocket custom. See snippets/quick-add-lite.liquid */
(function () {
  if (window.__orQuickAddLite) return;
  window.__orQuickAddLite = true;

  var sheet, overlay, listEl, titleEl, optEl, msgEl, linkEl, lastTrigger, current;

  function readData(btn) {
    var wrap = btn.closest('[data-qal]');
    var node = wrap && wrap.querySelector('[data-qal-data]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function build() {
    if (sheet) return;
    overlay = document.createElement('div');
    overlay.className = 'qal-overlay';
    overlay.hidden = true;
    sheet = document.createElement('div');
    sheet.className = 'qal-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'qal-sheet-title');
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="qal-sheet__grip" aria-hidden="true"></div>' +
      '<div class="qal-sheet__head">' +
      '<div><p class="qal-sheet__eyebrow">Quick Add</p><h2 class="qal-sheet__title" id="qal-sheet-title"></h2></div>' +
      '<button type="button" class="qal-sheet__close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<p class="qal-sheet__option"></p>' +
      '<div class="qal-sheet__sizes" role="group"></div>' +
      '<p class="qal-sheet__msg" role="status" aria-live="polite"></p>' +
      '<a class="qal-sheet__link" href="#">View full details</a>';
    document.body.appendChild(overlay);
    document.body.appendChild(sheet);
    listEl = sheet.querySelector('.qal-sheet__sizes');
    titleEl = sheet.querySelector('.qal-sheet__title');
    optEl = sheet.querySelector('.qal-sheet__option');
    msgEl = sheet.querySelector('.qal-sheet__msg');
    linkEl = sheet.querySelector('.qal-sheet__link');
    overlay.addEventListener('click', close);
    sheet.querySelector('.qal-sheet__close').addEventListener('click', close);
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trap(e);
    });
    listEl.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-id]');
      if (!b || b.disabled || sheet.classList.contains('is-busy')) return;
      add(b.getAttribute('data-id'), b);
    });
  }

  function trap(e) {
    var f = sheet.querySelectorAll('button:not([disabled]), a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(data, trigger) {
    build();
    current = data;
    lastTrigger = trigger;
    titleEl.textContent = data.title;
    optEl.textContent = 'Choose ' + String(data.option || 'size').toLowerCase();
    linkEl.href = data.url;
    msgEl.textContent = '';
    msgEl.classList.remove('is-error');
    listEl.setAttribute('aria-label', data.option || 'Size');
    listEl.innerHTML = '';
    data.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'qal-size';
      b.setAttribute('data-id', v.id);
      b.textContent = v.title;
      if (!v.available) {
        b.disabled = true;
        b.setAttribute('aria-label', v.title + ' – sold out');
        b.title = 'Sold out';
      }
      listEl.appendChild(b);
    });
    overlay.hidden = false;
    sheet.hidden = false;
    document.documentElement.classList.add('qal-lock');
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      sheet.classList.add('is-open');
      var firstSize = listEl.querySelector('button:not([disabled])');
      (firstSize || sheet.querySelector('.qal-sheet__close')).focus({ preventScroll: true });
    });
  }

  function close(opts) {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open', 'is-busy');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('qal-lock');
    setTimeout(function () { sheet.hidden = true; overlay.hidden = true; }, 220);
    if (!(opts && opts.keepFocus) && lastTrigger) lastTrigger.focus({ preventScroll: true });
  }

  function sectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : null;
  }

  function afterAdd(res, variantId) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
      drawer.classList.remove('is-empty');
      if (lastTrigger && drawer.setActiveElement) drawer.setActiveElement(lastTrigger);
      drawer.renderContents(res);
    } else if (res.sections && res.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var inner = sectionHTML(res.sections['cart-icon-bubble']);
      if (bubble && inner != null) bubble.innerHTML = inner;
    }
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add-lite', productVariantId: variantId, cartData: res });
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'quick-add-lite' } }));
  }

  function add(variantId, btn) {
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-icon-bubble'];
    if (btn) btn.classList.add('is-loading');
    if (sheet) sheet.classList.add('is-busy');
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return window
      .fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sections, sections_url: window.location.pathname })
      })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (r) {
        if (!r.ok || r.body.status) {
          var m = (r.body && (r.body.description || r.body.message)) || 'Sorry, that size could not be added.';
          if (sheet && !sheet.hidden) { msgEl.textContent = m; msgEl.classList.add('is-error'); }
          else window.alert(m);
          return false;
        }
        if (sheet && !sheet.hidden) close({ keepFocus: true });
        setTimeout(function () { afterAdd(r.body, variantId); }, sheet && !sheet.hidden ? 230 : 0);
        return true;
      })
      .catch(function () {
        if (sheet && !sheet.hidden) { msgEl.textContent = 'Something went wrong. Please try again.'; msgEl.classList.add('is-error'); }
        return false;
      })
      .finally(function () {
        if (btn) btn.classList.remove('is-loading');
        if (sheet) sheet.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qal-open]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var data = readData(btn);
    if (!data || !data.variants || !data.variants.length) { if (data && data.url) window.location.href = data.url; return; }
    lastTrigger = btn;
    var avail = data.variants.filter(function (v) { return v.available; });
    if (data.variants.length === 1 && avail.length === 1) {
      if (btn.classList.contains('is-loading')) return;
      add(avail[0].id, btn);
    } else {
      open(data, btn);
    }
  });
})();
